export default {
  index: [
    {
      path: '/zkequitycategory',
      component: resolve => require(['./zkequitycategoryIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkequitycategory/_router.js